import { render, staticRenderFns } from "./AIControl.vue?vue&type=template&id=e8d4aeba&scoped=true"
import script from "./AIControl.vue?vue&type=script&setup=true&lang=ts"
export * from "./AIControl.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AIControl.vue?vue&type=style&index=0&id=e8d4aeba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d4aeba",
  null
  
)

export default component.exports